'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:account:mobileLogin');
}

var _invoke = require('../invoke');

/**
 * 打开客户端登录界面
 *
 * 客户端不会判断是否已经登录。
 * 需要业务方自己调用 `hbnb.account.getUser` 判断是否已经登录。
 *
 * 支持版本
 * + iHotel/6.2
 *
 * @memberof account
 * @static
 * @name mobileLogin
 * @param mobile
 * @param code
 * @returns {Promise<user>} resolve if login success
 * @example
 *  hbnb.account.mobileLogin(19988887777, 123456)
 *      .then(function(user) {
 *          user = {
 *              userId: 1234567,
 *              userName: 'name is string',
 *              userToken: 'token is string'
 *          }
 *      })
 *      .catch(function(err) {
 *      })
 */

module.exports = function(mobile, code) {
    var p = new Promise(function(resolve, reject) {
        _invoke('user', 'mobile_login', {
            mobile: mobile,
            code: code,
            callback: function(user) {
                if (process.env.NODE_ENV !== 'production') {
                    debug('success, user is %j', user, user);
                }
                resolve(user);
            },
            errback: reject
        });
    });
    return p;
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/account/mobile-login.js
// module id = 569
// module chunks = 0